<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <b-card-title>
      Additional Visitor Safeguarding History
    </b-card-title>

    <section v-if="!loading">
      <b-table
        class="data-table"
        hover
        :items="history"
        :fields="headers"
        :current-page="currentPage"
        :per-page="filters.limit"
        :responsive="true"
      >
        <template #cell(created_at)="data">
          {{data.item.created_at | formatDateTime}}
        </template>
      </b-table>

      <b-row class="p-1" v-if="(totalRows > filters.limit) && totalRows !== 0">
        <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
          <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
        </b-col>
        <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No safeguarding history</p>
      </b-row>
    </section>

    <b-spinner v-else variant="primary" label="Loading..."></b-spinner>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';
  import {mapState} from 'vuex';
  import moment from 'moment';

  export default {
    components: {},
    props: {},
    data() {
      return {
        history: [],
        currentPage: 1,
        totalRows: 10,
        filters: {
          limit: 10,
        },
        loading: false,
        headers: [
          {
            key: 'prison_officer_name',
            label: 'Name',
          },
          {
            key: 'statusInfo',
            label: 'Status',
          },
          {
            key: 'createAt',
            label: 'Date',
          },
          {
            key: 'notes',
            label: 'Notes',
          },
        ],
      };
    },
    computed: {
      ...mapState({
        additionalVisitor: state => state.participants.participant,
      }),
    },
    mounted() {
      this.getHistory();
    },
    methods: {
      getHistory() {
        this.loading = true;

        AdditionalVisitorsService.getAdditionalVisitorsSafeguardingHistory(this.additionalVisitor.additional_visitor_id)
          .then(res => {
          this.totalRows = res.data.length;
          this.history = res.data.sort((s1, s2) => {
            const s1StartDate = new Date(s1.created_at);
            const s2StartDate = new Date(s2.created_at);
            return s2StartDate.getTime() - s1StartDate.getTime();
          }).map((safeguard) => {
            return {
              statusInfo: safeguard.status ? 'Completed' : 'Revoked',
              createAt: moment(safeguard.created_at).format('DD/MM/YYYY'),
              ...safeguard,
            };
          });
        }).catch(err => {
          console.log('error', err);
          this.$toast.error('Error getting safeguarding history, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
